exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-background {\r\n    margin-top: 20px;\r\n    padding: 30px 0;\r\n}\r\n\r\n.m-top1 {\r\n    margin-top: 8px;\r\n}\r\n\r\n.required:after {\r\n    content:\" *\";\r\n    color: #d00;\r\n}\r\n\r\n.invalid-feedback {\r\n    width: 100%;\r\n    margin-top: 0.25rem;\r\n    font-size: 90%;\r\n    color: #df382c;\r\n}\r\n.fa-eraser {\r\n    width: 15px;\r\n    margin: -25px 10px;\r\n    float: right;\r\n}\r\n\r\n.information-module {\r\n    cursor: pointer;\r\n    color: #3c8dbc;\r\n}\r\n\r\n.information-module:hover {\r\n    text-decoration: underline;\r\n    color: #00a7d0;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/register/register.component.css
// module id = ../../../../../src/app/_components/register/register.component.css
// module chunks = main